import axios from '../utils/axiosConfig';

const reportAPI = {
  // Create a report
  createReport: async (data) => {
    const response = await axios.post('/reports', data);
    return response.data;
  },

  // Get user's reports
  getUserReports: async (params = {}) => {
    const response = await axios.get('/reports/my-reports', { params });
    return response.data;
  },

  // Get report reasons
  getReportReasons: async () => {
    const response = await axios.get('/reports/reasons');
    return response.data;
  },

  // Admin endpoints
  getReports: async (params = {}) => {
    const response = await axios.get('/reports', { params });
    return response.data;
  },

  getReportStats: async () => {
    const response = await axios.get('/reports/stats');
    return response.data;
  },

  getReportById: async (reportId) => {
    const response = await axios.get(`/reports/${reportId}`);
    return response.data;
  },

  updateReportStatus: async (reportId, data) => {
    const response = await axios.patch(`/reports/${reportId}/status`, data);
    return response.data;
  },
};

export default reportAPI;